"use client";
// import React from 'react';
// import { ResumeData } from '@/lib/schema';

// // Helper function to handle both old and new language formats
// const getLanguageName = (lang: string | { name: string }): string => {
//   return typeof lang === 'string' ? lang : lang.name;
// };

// export default function ActorProfile({ data }: { data: ResumeData }) {
//   const { basics, experience, education, skills } = data;
//   const hardSkills = skills.slice(0, 2);
//   const softSkills = skills.slice(2, 4);
//   const otherSkills = skills.slice(4);

//   return (
//     <div className="bg-gray-50 min-h-screen font-sans p-0">
//       {/* Header with photo */}
//       <div
//         className="
//           bg-blue-900 text-white
//           flex flex-col md:flex-row items-center p-6
//           print:flex-row print:items-center print:justify-start
//         "
//       >
//         {basics.photo && (
//           <img
//             src={basics.photo}
//             alt="Profile"
//             className="
//               w-28 h-28 rounded-full border-4 border-white object-cover
//               mb-4 md:mb-0 md:mr-6
//               print:mb-0 print:mr-6 print:max-w-28 print:max-h-28 print:object-cover print:border print:border-gray-400 print:shadow-none
//             "
//           />
//         )}
//         <div className="flex-1 text-center md:text-left print:text-left">
//           <h1 className="text-2xl font-bold">{basics.name}</h1>
//           <h2 className="text-lg italic text-blue-200">{basics.title}</h2>
//           <p className="mt-2 text-sm text-blue-100">{basics.summary}</p>
//         </div>
//       </div>

//       {/* Contact bar */}
//       <div className="flex flex-wrap justify-center md:justify-start print:justify-start gap-4 bg-teal-500 text-white py-2 px-6 text-sm">
//         {basics.email && <span>📧 {basics.email}</span>}
//         {basics.phone && <span>📞 {basics.phone}</span>}
//         {basics.location && <span>📍 {basics.location}</span>}
//         {basics.social &&
//           basics.social.map((s, i) => <span key={i}>🔗 {s.url}</span>)}
//       </div>

//       {/* Main content */}
//       <div className="flex flex-col md:flex-row print:flex-row gap-6 mt-6 max-w-5xl mx-auto p-6">
//         {/* Left/Main column */}
//         <div className="flex-1 space-y-6">
//           {/* Work Experience */}
//           <section>
//             <h2 className="flex items-center gap-2 text-lg font-bold text-blue-900 mb-2">
//               💼 Work Experience
//             </h2>
//             {experience.map((exp, idx) => (
//               <div key={idx} className="mb-3">
//                 <div className="font-semibold text-gray-500">
//                   {exp.role}{' '}
//                   <span className="text-gray-500">@ {exp.company}</span>
//                 </div>
//                 <div className="text-xs text-gray-500 mb-1">
//                   {exp.startDate} - {exp.current ? 'Present' : exp.endDate}
//                 </div>
//                 {exp.summary && (
//                   <ul className="list-disc ml-5 text-sm text-gray-700">
//                     <li>{exp.summary}</li>
//                   </ul>
//                 )}
//               </div>
//             ))}
//           </section>

//           {/* Workshops/Training */}
//           {/* <section>
//             <h2 className="flex items-center gap-2 text-lg font-bold text-blue-900 mb-2">
//               🎭 Workshops & Training Camps
//             </h2>
//             {education.map((edu, idx) => (
//               <div key={idx} className="mb-2">
//                 <div className="font-semibold text-gray-500">
//                   {edu.degree || 'Workshop'}{' '}
//                   <span className="text-gray-500">
//                     {edu.institution && `- ${edu.institution}`}
//                   </span>
//                 </div>
//                 <div className="text-xs text-gray-500">
//                   {edu.startDate} - {edu.endDate}
//                 </div>
//               </div>
//             ))}
//           </section> */}
//         </div>

//         {/* Right/Sidebar column */}
//         <div className="w-full md:w-72 print:w-72 flex-shrink-0 space-y-6">
//           {/* Hard Skills */}
//           <section>
//             <h2 className="flex items-center gap-2 text-md font-bold text-blue-900 mb-2">
//               🛠️ Skills
//             </h2>
//             <ul className="list-disc ml-5 text-sm text-gray-700">
//               {skills.map((skill, idx) => (
//                 <li key={idx}>{skill}</li>
//               ))}
//             </ul>
//           </section>

//           {/* Soft Skills
//           <section>
//             <h2 className="flex items-center gap-2 text-md font-bold text-blue-900 mb-2">
//               🤝 Soft Skills
//             </h2>
//             <ul className="list-disc ml-5 text-sm text-gray-700">
//               {softSkills.map((skill, idx) => (
//                 <li key={idx}>{skill}</li>
//               ))}
//             </ul>
//           </section> */}

//           {/* Education */}
//           <section>
//             <h2 className="flex items-center gap-2 text-md font-bold text-blue-900 mb-2">
//               🎓 Education
//             </h2>
//             {education.map((edu, idx) => (
//               <div key={idx} className="mb-2">
//                 <div className="font-semibold text-gray-500">{edu.degree}</div>
//                 <div className="text-xs text-gray-500">{edu.institution}</div>
//                 <div className="text-xs text-gray-500">
//                   {edu.startDate} - {edu.endDate}
//                 </div>
//               </div>
//             ))}
//           </section>

//           {/* Languages */}
//           {basics.languages && basics.languages.length > 0 && (
//             <section>
//               <h2 className="flex items-center gap-2 text-md font-bold text-blue-900 mb-2">
//                 🌐 Languages
//               </h2>
//               <ul className="list-disc ml-5 text-sm text-gray-700">
//                 {basics.languages
//                   .map((lang) => getLanguageName(lang as string | { name: string }))
//                   .map((langName, idx) => (
//                     <li key={idx}>{langName}</li>
//                   ))}
//               </ul>
//             </section>
//           )}

//           {/* Hobbies & Interests */}
//           {basics.hobbies && basics.hobbies.length > 0 && (
//             <section>
//               <h2 className="flex items-center gap-2 text-md font-bold text-blue-900 mb-2">
//                 🎨 Hobbies & Interests
//               </h2>
//               <ul className="list-disc ml-5 text-sm text-gray-700">
//                 {basics.hobbies.map((hobby, idx) => (
//                   <li key={idx}>{hobby}</li>
//                 ))}
//               </ul>
//             </section>
//           )}

//           {/* Strengths Section - Only show if data exists */}
//           {basics.strengths && basics.strengths.length > 0 && (
//             <section>
//               <h2 className="flex items-center gap-2 text-md font-bold text-blue-900 mb-2">
//                 💪 Strengths
//               </h2>
//               <div className="space-y-2">
//                 {basics.strengths.map((strength, idx) => (
//                   <div key={idx}>
//                     <div className="font-semibold text-gray-600 text-sm">{strength.title}</div>
//                     {strength.description && (
//                       <div className="text-xs text-gray-500">{strength.description}</div>
//                     )}
//                   </div>
//                 ))}
//               </div>
//             </section>
//           )}

//           {/* Key Achievements Section - Only show if data exists */}
//           {basics.achievements && basics.achievements.length > 0 && (
//             <section>
//               <h2 className="flex items-center gap-2 text-md font-bold text-blue-900 mb-2">
//                 🏆 Key Achievements
//               </h2>
//               <div className="space-y-2">
//                 {basics.achievements.map((achievement, idx) => (
//                   <div key={idx}>
//                     <div className="font-semibold text-gray-600 text-sm">{achievement.title}</div>
//                     {achievement.description && (
//                       <div className="text-xs text-gray-500">{achievement.description}</div>
//                     )}
//                   </div>
//                 ))}
//               </div>
//             </section>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// }


import React from "react";
import { ResumeData } from "@/lib/schema";
import {
  FaEnvelope,
  FaPhoneAlt,
  FaMapMarkerAlt,
  FaGithub,
  FaLinkedin,
  FaGlobeAsia,
  FaGraduationCap,
  FaLanguage,
  FaBriefcase,
  FaUserCog,
} from "react-icons/fa";

type Language = string | { name: string };

const getLanguageName = (lang: Language): string =>
  typeof lang === "string" ? lang : lang.name;

// ICON HELPERS
const getSocialIcon = (label: string) => {
  if (label.toLowerCase().includes("github")) return <FaGithub style={{ marginRight: 6 }} />;
  if (label.toLowerCase().includes("linkedin")) return <FaLinkedin style={{ marginRight: 6 }} />;
  if (label.toLowerCase().includes("website")) return <FaGlobeAsia style={{ marginRight: 6 }} />;
  return <FaGlobeAsia style={{ marginRight: 6 }} />;
};

interface ActorProfileProps {
  data: ResumeData;
}

const styles = {
  bgHeader: {
    background: "#213a72",
    color: "white",
    padding: "32px 0 20px 0",
    display: "flex",
    flexDirection: "row" as const,
    alignItems: "center",
    gap: "32px",
    minHeight: "120px",
    borderTopLeftRadius: "6px",
    borderTopRightRadius: "6px",
    position: "relative" as const,
    zIndex: 1,
  },
  avatar: {
    width: "90px",
    height: "90px",
    borderRadius: "50%",
    objectFit: "cover" as const,
    border: "4px solid #fff",
    marginLeft: "32px",
    background: "#e5e7eb",
    flexShrink: 0,
  },
  headerCol: {
    flex: 1,
    display: "flex",
    flexDirection: "column" as const,
    justifyContent: "center",
    alignItems: "flex-start",
    minWidth: 0,
  },
  name: {
    fontWeight: 700,
    fontSize: 25,
    color: "#fff",
    letterSpacing: 0.5,
    marginBottom: 2,
    marginTop: 0,
  },
  subtitle: {
    fontWeight: 400,
    fontSize: 17,
    color: "#b4e0ff",
    fontStyle: "italic",
    marginBottom: 6,
  },
  summary: {
    color: "#e0e6ed",
    fontSize: 14,
    minHeight: "20px",
    maxWidth: 450,
    margin: 0,
  },
  contactBar: {
    background: "#0cc4ac",
    display: "flex",
    flexDirection: "row" as const,
    alignItems: "center",
    gap: "24px",
    padding: "8px 40px",
    fontSize: "14px",
  },
  contactIcon: { marginRight: 6, opacity: 0.85 },
  contactText: { color: "#fff" },
  main: {
    display: "flex",
    flexDirection: "row" as const,
    maxWidth: 1000,
    margin: "36px auto",
    gap: "36px",
    alignItems: "flex-start",
    justifyContent: "center",
    padding: "0 24px 24px 24px",
    background: "#f8fafc",
    borderBottomLeftRadius: "6px",
    borderBottomRightRadius: "6px",
    minHeight: 600,
  },
  leftCol: {
    flex: 3,
    minWidth: 0,
  },
  rightCol: {
    flex: 2.2,
    minWidth: 220,
    maxWidth: 270,
    marginLeft: 20,
  },
  sectionTitle: {
    display: "flex",
    alignItems: "center",
    fontWeight: 700,
    fontSize: "18px",
    color: "#213a72",
    marginBottom: "12px",
    gap: "8px",
    marginTop: "20px",
  },
  sectionTitleRight: {
    color: "#213a72",
    fontSize: "16px",
    margin: "18px 0 10px",
    fontWeight: 700,
    display: "flex",
    alignItems: "center",
    gap: "6px",
  },
  jobRole: {
    fontWeight: 600,
    fontSize: "15px",
    color: "#27272a",
    marginTop: 8,
    marginBottom: 2,
  },
  jobMeta: {
    fontSize: 13,
    color: "#777",
    marginBottom: 0,
    marginTop: 0,
  },
  jobSummary: {
    fontSize: 14,
    color: "#23272f",
    margin: "4px 0 0 0",
    lineHeight: 1.6,
  },
  bulletList: {
    paddingLeft: "18px",
    margin: "4px 0",
  },
  skillList: {
    listStyle: "disc outside",
    marginLeft: "18px",
    marginBottom: 0,
    paddingLeft: 0,
    fontSize: "14px",
    color: "#23272f",
  },
  skillListItem: { margin: "4px 0" },
  eduSchool: { fontWeight: 600, color: "#1e293b", fontSize: "14px" },
  eduMeta: { fontSize: "13px", color: "#555", marginBottom: "2px" },
  langItem: { fontSize: "14px", color: "#23272f", margin: "1px 0" },
};

export default function ActorProfile({ data }: ActorProfileProps) {
  const { basics, experience, education, skills } = data;
  const social = basics.social ?? [];
  const languages: Language[] = basics.languages ?? [];

  return (
    <div>
      {/* Header */}
      <div style={styles.bgHeader}>
        {basics.photo && (
          <img src={basics.photo} alt="Profile" style={styles.avatar} />
        )}
        <div style={styles.headerCol}>
          <h1 style={styles.name}>{basics.name}</h1>
          <h2 style={styles.subtitle}>{basics.title}</h2>
          {basics.summary && <p style={styles.summary}>{basics.summary}</p>}
        </div>
      </div>

      {/* Contact Bar */}
      <div style={styles.contactBar}>
        {basics.email && (
          <span style={styles.contactText}>
            <FaEnvelope style={styles.contactIcon} />
            {basics.email}
          </span>
        )}
        {basics.phone && (
          <span style={styles.contactText}>
            <FaPhoneAlt style={styles.contactIcon} />
            {basics.phone}
          </span>
        )}
        {basics.location && (
          <span style={styles.contactText}>
            <FaMapMarkerAlt style={styles.contactIcon} />
            {basics.location}
          </span>
        )}
        {social.map((s, i) => (
          <span key={i} style={styles.contactText}>
            {getSocialIcon(s.label)}
            {s.url}
          </span>
        ))}
      </div>

      {/* Main two-column layout */}
      <div style={styles.main}>
        {/* Left Column: Work Experience */}
        <div style={styles.leftCol}>
          <div style={styles.sectionTitle}>
            <FaBriefcase />
            Work Experience
          </div>
          {experience.map((exp, idx) => (
            <div key={idx}>
              <div style={styles.jobRole}>
                {exp.role}
                {" "}
                <span style={{ color: "#474b59" }}>@ {exp.company}</span>
              </div>
              <div style={styles.jobMeta}>
                {exp.startDate} - {exp.current ? "Present" : exp.endDate}
              </div>
              {exp.summary && (
                <ul style={styles.bulletList}>
                  <li style={styles.jobSummary}>{exp.summary}</li>
                </ul>
              )}
            </div>
          ))}
        </div>

        {/* Right Column: Skills, Education, Languages */}
        <div style={styles.rightCol}>
          <div style={styles.sectionTitleRight}>
            <FaUserCog />
            Skills
          </div>
          <ul style={styles.skillList}>
            {skills.map((skill, idx) => (
              <li key={idx} style={styles.skillListItem}>
                {skill}
              </li>
            ))}
          </ul>
          <div style={styles.sectionTitleRight}>
            <FaGraduationCap />
            Education
          </div>
          {education.map((edu, idx) => (
            <div key={idx} style={{ marginBottom: 10 }}>
              <div style={styles.eduSchool}>{edu.degree}</div>
              <div style={styles.eduMeta}>{edu.institution}</div>
              <div style={styles.eduMeta}>
                {edu.startDate} - {edu.endDate}
              </div>
            </div>
          ))}
          {languages.length > 0 && (
            <>
              <div style={styles.sectionTitleRight}>
                <FaLanguage />
                Languages
              </div>
              <ul style={styles.skillList}>
                {languages.map((lang, idx) => (
                  <li key={idx} style={styles.langItem}>
                    {getLanguageName(lang)}
                  </li>
                ))}
              </ul>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
